import React from 'react';
import styles from './RightSidebarContainer.module.scss';
import MiniTrigger from '../../../../components/Sidebar/HelperSidebar/MiniTrigger';
import cx from 'classnames';
import SidebarTabs from '../SidebarTabs/SidebarTabs';
import CloseButton from '../../../../components/CloseButton/CloseButton';

const RightSidebarContainer = ({
    children,
    mini,
    classNames,
    miniClassNames,
    showHeader,
    tabs,
    defaultTitle,
    toggleMiniSidebar,
    handleClose,
}) => {
    const {
        options = [],
        state = null,
        onChangeTab = () => { },
    } = tabs;
    return (
        <div
            className={cx(styles.wrapper, classNames, {
                [styles.miniSidebar]: mini,
                [miniClassNames]: mini,
            })}
        >
            <div className={styles.container}>
                {showHeader ? null : (
                    <div className={cx(styles.headerWrapper, { [styles.onlyEditor]: options === null })}>
                        {options ?
                            (
                                <SidebarTabs options={options} currentState={state} onClick={onChangeTab} mini={mini} />
                            ) : (
                                <h2 className={styles.title}>{defaultTitle}</h2>
                            )}
                        <CloseButton onClose={handleClose} />
                    </div>
                )}
                {children}
            </div>
            <MiniTrigger mini={mini} toggle={toggleMiniSidebar} menuSite={'right'} />
        </div>
    );
};

export default RightSidebarContainer;